/*
 * Model for getting code list data
 */
angular.module('taric.model.codelists', ['common.helper', 'ngResource', 'common.config'])
    .factory('CodeLists', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/cl/codetypes', {}, {
        queryAllCodeTypes: {
            method: 'GET',
            isArray: false
        },
        queryCodeTypeChildren: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cl/:codetype'
        },
        queryHtmlCodeTypes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cl/htmlcodetypes'
        }
    });
}).service('CodeListsModel', function ($q, CodeLists, CommonHelper, $translate, CONSTANTS) {
    var model = this;

    var searchCriteria = {},
        searchResult = null,
        viewResult = null,
        selectedCodelist = null;

    model.getSearchResult = function () {
        return searchResult;
    };

    model.getViewResult = function () {
        return viewResult;
    };

    model.resetSearchResult = function () {
        searchResult = null;
    };

    model.resetViewResult = function () {
        viewResult = null;
    };

    model.resetSearchCriteria = function () {
        // Set the default search criteria when the model is initialized
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.codeType = "";
        searchCriteria.ascending = true;
        searchCriteria.language = CommonHelper.getLanguageCode(CONSTANTS.availableLanguages[0]);
    };

    model.reset = function(){
        model.resetSearchCriteria();
        model.resetSearchResult();
    };

    model.reset();

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.getSelectedCodelist = function () {
        return selectedCodelist;
    };
    model.setSelectedCodelist = function (codelist) {
        selectedCodelist = codelist;
    };

    model.queryAllCodeTypes = function (pageNumber) {
        var deferred = $q.defer();

        var options = {
            startDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            endDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            codetype: CommonHelper.removeSpaceCharacters(searchCriteria.codeType),
            language: searchCriteria.language,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };
        
        if (pageNumber) {
            options.offset =  CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = CodeLists.queryAllCodeTypes(options, function () {

            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.codeTypeResult = result.items;
            returnedResult.currentPage = pageNumber;

            searchResult = returnedResult;
            deferred.resolve(returnedResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.queryCodeTypeChildren = function (pageNumber) {
        var deferred = $q.defer();

        var codeType = null;
        if (selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'ADD' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'MCT' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'GCR' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'GGP' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'FOO' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'REL' ||
                selectedCodelist.codeTypeId && selectedCodelist.codeTypeId === 'BLT') {
            codeType = selectedCodelist.codeTypeId;
        }

        var options = {
            codetype: codeType,
            type: selectedCodelist.type,
            applicableDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            language: searchCriteria.language,
            sortOrder: searchCriteria.ascending ? 'A' : 'D',
            sortColumn: searchCriteria.sortCol
        };

        if (pageNumber) {
            options.offset =  CommonHelper.getOffset(pageNumber);
            options.count = CONSTANTS.rowsPerPage;
        }

        var result = CodeLists.queryCodeTypeChildren(options, function () {
            viewResult = {};
            viewResult.totalItems = result.count;
            viewResult.codeTypeChildrenResult = result.items;

            if (pageNumber) {
                viewResult.currentPage = pageNumber;
            }

            deferred.resolve(viewResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.queryHtmlCodeTypes = function () {
        var deferred = $q.defer();

        var options = {
            codetype: CommonHelper.removeSpaceCharacters(searchCriteria.codeType),
            language: searchCriteria.language
        };

        var result = CodeLists.queryHtmlCodeTypes(options, function () {
            searchResult = {};
            searchResult.htmlTypeContent = result.htmlTypeContent;

            deferred.resolve(searchResult);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getSelectedRow = function () {
        return model.queryCodeTypeChildren();
    };

});



// WEBPACK FOOTER //
// ./app/taric/moreinfo/codelists/shared/codelists-model.js